import React from 'react';
import useFetchSpatialLayers from '../../hooks/useFetchSpatialLayers';
import MapLayersControl from './MapLayersControl';

/**
 * Check if user has access to spatial layers capabilities
 */

const MapLayersControlContainer = () => {
  const isFetched = useFetchSpatialLayers();

  if (isFetched) {
    return <MapLayersControl />;
  }
  return null;
};

export default MapLayersControlContainer;
